import type { GoalCardProps } from './types'
import { CardContainer, CardTitle } from '../common/styles'
import { ProgressRow } from '../ProgressRow'
import { getProgressColor, calculatePercentage } from '../common/utils'

export const GoalCard = ({
  title,
  value = 0,
  expectedValue = 0
}: GoalCardProps) => {
  const percentage = calculatePercentage(value, expectedValue)
  const progressColor = getProgressColor(percentage)

  return (
    <CardContainer>
      <CardTitle>{title}</CardTitle>
      <ProgressRow
        small
        leftValue={expectedValue}
        leftFormat="currency"
        rightValue={percentage}
        rightFormat="percentage"
        rightColor={progressColor}
        progressValue={percentage}
        progressColor={progressColor}
      />
    </CardContainer>
  )
}
